import { canApproveForm } from '../onboarding-action-policy.service';
import templateUrl from './w9.component.html';
import moment from 'moment';
import { PreviewSignatureModal } from '../preview-signature-modal/preview-signature-modal.component';
import { InfoModal } from '../info-modal/info-modal.component';


export const W9Component = {
    templateUrl,
    controller: W9Controller,
    controllerAs: "vm",
    bindings: {
        resolve: "<",
        ownerView: "<",
        owner: "<",
        employee: "<",
        employeeProfile: "<",
        profile: "<",
        employeeBankInfo: "<",
        provinces: "<",
        application: "<",
        genderOptions: "<",
        userInputs: "<",
        savedInputs: "<",
        maritalStatus: "<",
        close: "&",
        dismiss: "&"
    }
};


function W9Controller(onboardingActionPolicy, onboardingDocumentService, $state, $scope, $uibModal, $q,
    utilityService, localeService) {
    'ngInject';
    const vm = this;
    // APEX-977: read-only View mode (locked forms) - hides inline Edit, keeps fields disabled.
    vm.isViewOnly = () => !!vm.application && onboardingActionPolicy.getButtonTitle('-2', vm.application) === 'View';

    vm.taxForm;
    vm.onPreview = onPreview;
    vm.onPreviewInPage = onPreviewInPage;
    vm.onDocDownload = onDocDownload;
    vm.onSubmit = onSubmit;
    vm.onShowI9 = onShowI9;
    vm.onClose = onClose;
    vm.onShowFederalW4 = onShowFederalW4;
    vm.onRequestReview = onRequestReview;
    vm.onSave = onSave;
    vm.revealSSNChar = revealSSNChar;
    vm.revealFEINChar = revealFEINChar;
    vm.retrieveLocale = retrieveLocale;
    vm.retrieveLocaleTranslations = retrieveLocaleTranslations;
    vm.ssnIsValidated = ssnIsValidated;
    vm.validateEIN = validateEIN;
    vm.ssnBlur = ssnBlur;
    vm.onEditClicked = onEditClicked;
    vm.onApprove = onApprove;

    vm.reqReview = false;
    vm.isSigned = false;
    vm.prefilled = false;
    vm.disableEmpFields = true;
    vm.disableEmprFields = false;
    vm.isSaved = false;
    vm.showSavedNotification = false;
    vm.editable = true;
    vm.savedData = false;
    vm.previewUrl;
    vm.isCompany = false;
    vm.state = {
        view: 'W4'
    };


    vm.$onInit = function () {
        console.log(vm.resolve);
        // spread resolve variables
        if (vm.resolve) {
            Object.assign(vm, vm.resolve);
        }

        vm.reqReview = false;
        vm.date = moment(new Date(), 'MM/DD/YYYY').toDate();
        vm.stateProvinces = this.provinces;
        vm.userProfile = this.profile;
        //get locale
        vm.retrieveLocale()
            .then(function (locale) {
                console.log(locale);
                return vm.retrieveLocaleTranslations(locale.localeID);
            })
            .then(function (translations) {
                vm.employeeBankInfo.Translations = translations;
            });
        if (vm.addlInputs.hasOwnProperty("OnboardingType")) {
            if (vm.addlInputs["OnboardingType"] === 'i' || vm.addlInputs["OnboardingType"] === 'e') {
                //vm.employeeBankInfo.taxNumberDisplayed = 'ssn';
                vm.hasOnbTypeFlag = true;
            } else if (vm.addlInputs["OnboardingType"] === 'c') {
                //vm.employeeBankInfo.taxNumberDisplayed = 'fein';
                vm.hasOnbTypeFlag = true;
                vm.isCompany = true;
            }
        }
        //load application data
        if (vm.savedInputs != null && vm.savedInputs.EntityName != null && !vm.ownerView) {
            console.log(vm.savedInputs);
            vm.savedData = true;
            vm.showSavedNotification = true;
            fillEmployee(vm.savedInputs);
            //default to user profile
            vm.entityName = vm.employeeProfile.FullName;
            vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
            vm.employeeFein = vm.employeeBankInfo.CurrentFEIN;
            vm.address = [vm.profile.HomeAddress.StreetLine1, vm.profile.HomeAddress.StreetLine2, vm.profile.HomeAddress.AptNum].filter(Boolean).join(', ');
            vm.city = vm.profile.HomeAddress.City;
            vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID);
            vm.zipCode = vm.profile.HomeAddress.PostalCode;
        } else if (vm.userInputs != null && vm.userInputs.EntityName != null) {
            //prefill this.userInputs
            if (this.application) {
                vm.editable = !(this.application && this.application.HasFW4Form !== null && this.application.W9 !== 'Review' && this.application.W9 !== 'Submitted' && this.application.W9 !== 'Pending');
            }
            fillEmployee(vm.userInputs);
            // Match Federal W-4: re-pull identity (name/SSN/FEIN/address/city/
            // state/zip) from the resolve variables so a stale saved value
            // isn't shown or submitted while the form is still Pending.
            if (vm.application.W9 === 'Pending') {
                fillLockedInfo();
            }
        } else {
            //prefill user info
            //vm.taxForm.$setDirty();
            vm.entityName = vm.employeeProfile.FullName;
            vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
            vm.employeeFein = vm.employeeBankInfo.CurrentFEIN;
            vm.address = [vm.profile.HomeAddress.StreetLine1, vm.profile.HomeAddress.StreetLine2, vm.profile.HomeAddress.AptNum].filter(Boolean).join(', ')
            vm.city = vm.profile.HomeAddress.City;
            vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID);
            vm.zipCode = vm.profile.HomeAddress.PostalCode;
        }
        if (vm.application.ApplicationStatus === 'Approved' || vm.application.ApplicationStatus === 'Submitted') {
            vm.editable = false;
        }
        vm.editable = resolveEditable();
        utilityService.hideLoading();
    }

    function resolveEditable() {
        const appStatus = vm.application.ApplicationStatus;
        const formStatus = vm.application.W9;

        // ReviewRequired: always directly editable so the employee can fix it
        if (formStatus === 'ReviewRequired') return true;
        if (appStatus === 'Approved' || appStatus === 'Submitted') return false;
        // Submitted or Approved form: locked so the Edit button shows
        if (formStatus === 'Submitted' || formStatus === 'Approved') return false;
        if (appStatus === 'Pending') {
            // Active employees: skip edit button, directly editable
            // Pending employees (new hire): start locked so edit button is shown
            return formStatus === 'Pending' || vm.application.EmployeeStatus !== 'Pending';
        }

        return !vm.application.HasFW4Form       // ? HasFW4Form, same as original
            || formStatus === 'Pending'
            || formStatus === 'ReviewRequired';
    }


    function onEditClicked() {
        vm.editable = !vm.editable;
        if (vm.employeeProfile != null && vm.employeeProfile.EmployeeStatusID === 1 && vm.application.ApplicationStatus === 'Pending') {
            vm.entityName = vm.employeeProfile.FullName;
            vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
            vm.employeeFein = vm.employeeBankInfo.CurrentFEIN;
            vm.address = [vm.profile.HomeAddress.StreetLine1, vm.profile.HomeAddress.StreetLine2, vm.profile.HomeAddress.AptNum].filter(Boolean).join(', ');
            vm.city = vm.profile.HomeAddress.City;
            vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID);
            vm.zipCode = vm.profile.HomeAddress.PostalCode;
        }
    }

    // Overwrites the identity fields from the resolve variables (employee
    // profile + bank info). Mirrors Federal W-4 fillLockedInfo and the block
    // already used in the savedInputs and fresh branches below/above.
    function fillLockedInfo() {
        vm.entityName = vm.employeeProfile.FullName;
        vm.employeeSsn = vm.employeeBankInfo.CurrentSSN;
        vm.employeeFein = vm.employeeBankInfo.CurrentFEIN;
        vm.address = [vm.profile.HomeAddress.StreetLine1, vm.profile.HomeAddress.StreetLine2, vm.profile.HomeAddress.AptNum].filter(Boolean).join(', ');
        vm.city = vm.profile.HomeAddress.City;
        vm.stateProvince = vm.stateProvinces.find(x => x.StateProvinceID === vm.profile.HomeAddress?.StateProvinceID);
        vm.zipCode = vm.profile.HomeAddress.PostalCode;
    }

    function fillEmployee(data) {
        vm.prefilled = true;
        vm.entityName = data.EntityName;
        vm.businessName = data.BusinessName;
        vm.address = [vm.profile.HomeAddress.StreetLine1, vm.profile.HomeAddress.StreetLine2, vm.profile.HomeAddress.AptNum].filter(Boolean).join(', ');
        vm.city = data.City;
        vm.zipCode = data.ZipCode;
        vm.stateProvince = vm.stateProvinces.find(x => x.Abbr === data.State);
        if (data.Ssn1 != null) {
            vm.employeeSsn = [data.Ssn1, data.Ssn2, data.Ssn3].filter(Boolean).join('');
        }
        if (data.Ein1 != null) {
            vm.employeeFein = [data.Ein1, data.Ein2].filter(Boolean).join('');
        }
        vm.taxClass = data.TaxClassification
        if (data.TaxClassification === 'LLC') {
            vm.llctaxclass = data.LLCClassification;
        } else if (data.TaxClassification === 'Oth') {
            vm.othtaxclass = data.OwnerTaxClassification
        }
        vm.line3a = data.Line3a;
        vm.exemptpayeecode = data.ExemptPayeeCode;
        vm.complianceact = data.ComplianceAct;
        vm.accnos = data.AccNos;
        vm.reqnameaddress = data.ReqNameAddress;
        //vm.filingStatus = data.FilingStatus;
        //vm.regularWithholding = data.RegularWithholdingAllowance;
        //vm.estimatedDeductions = data.EstimatedDeductions;
        //vm.totalAllowances = data.TotalAllowances;
        //vm.addlAmount = data.AddlAmount;
        //vm.whexempt = data.WHexempt;
        //vm.notsub2wh = data.NotSubj2WH;

        if (data.Signature) {
            vm.signimage = data.Signature;
            vm.isSigned = true;

        }
        vm.date = moment(data.Date, 'MM/DD/YYYY').toDate();
    }

    //event to track if user changed any form data
    $scope.$watch('vm.taxForm.$dirty', function (value) {
        if (value) {
            vm.prefilled = false;
        }
    }, false);

    //request review
    function onRequestReview() {
        const trans = onboardingDocumentService.saveComment({
            ApplicationId: vm.application.ApplicationId,
            UserName: vm.owner.UserName,
            Text: vm.commentText,
        }).then((res) => {
            if (res) return onboardingDocumentService.setReviewRequired(vm.employee.EmployeeID, '-2');
        }).then(() => {
            vm.close({ $value: 'ok' });
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, 'Request review failed')
        );
    }

    function validateEIN() {
        if (vm.ein !== null && vm.ein.length !== 9) {
            vm.taxForm.ein.$setValidity('length', false);
        } else {
            vm.taxForm.ein.$setValidity('length', true);
        }
    }

    //info document
    function onDocDownload() {
        utilityService.showLoading();
        return onboardingDocumentService.retrieveTemplate(vm.employee.UserName, '-2', '0').then(function (result) {
            utilityService.hideLoading();
            return result;
        }).then(function () {
            utilityService.hideLoading();
        });

    }

    //preview popup
    function onPreviewInPage() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();

        vm.ssnfein = vm.employeeSsn ?? vm.employeeFein;
        let formData = {
            RequestTypeId: '-2',
            IsI9EmployeeMode: !vm.ownerView,
            EntityName: vm.entityName,
            BusinessName: vm.businessName,
            TaxClassification: vm.taxClass,
            OwnerTaxClassification: vm.othtaxclass,
            LLCClassification: vm.llctaxclass,
            ExemptPayeeCode: vm.exemptpayeecode,
            ComplianceAct: vm.complianceact,
            Line3a: vm.line3a === 'true',
            ReqNameAddress: vm.reqnameaddress,
            AccNos: vm.accnos,
            Address: vm.address,
            W9CityState: [vm.city, vm.stateProvince.Abbr, vm.zipCode].filter(Boolean).join(', '),
            City: vm.city,
            State: vm.stateProvince.Abbr,
            ZipCode: vm.zipCode,
            Date: moment(vm.date, 'MM/DD/YYYY').format('MM/DD/YYYY'),
            //Signature: vm.signimage,
        };
        if (vm.employeeBankInfo.CurrentSSN) {
            let ssnData = {
                Ssn1: vm.employeeSsn.slice(0, 3),
                Ssn2: vm.employeeSsn.slice(3, 5),
                Ssn3: vm.employeeSsn.slice(5)
            }
            formData = { ...formData, ...ssnData }
        }
        if (vm.employeeBankInfo.CurrentFEIN) {
            let feinData = {
                Ein1: vm.employeeFein.slice(0, 2),
                Ein2: vm.employeeFein.slice(2)
            }
            formData = { ...formData, ...feinData }
        }
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, 0)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...PreviewSignatureModal,
                    resolve: {
                        title: () => "W9",
                        previewUrl: () => {
                            return vm.previewUrl;
                        }
                    }
                }).result
            }).then(function (data) {
                console.log(data);
                vm.signimage = data.dataUrl;
                vm.isSigned = data.dataUrl != null;
                //vm.ISPreview = true;
                return onSubmit();
            }).catch((err) => {
                utilityService.hideLoading();
                console.log(err)
            });

    }

    //save
    function onSave() {
        utilityService.showLoading();
        let formData = {
            RequestTypeId: '-2',
            IsI9EmployeeMode: !vm.ownerView,
            EntityName: vm.entityName,
            BusinessName: vm.businessName,
            TaxClassification: vm.taxClass,
            OwnerTaxClassification: vm.othtaxclass,
            LLCClassification: vm.llctaxclass,
            ExemptPayeeCode: vm.exemptpayeecode,
            ComplianceAct: vm.complianceact,
            Line3a: vm.line3a === 'true',
            ReqNameAddress: vm.reqnameaddress,
            AccNos: vm.accnos,
            Address: vm.address,
            City: vm.city,
            W9CityState: [vm.city, vm.stateProvince.Abbr, vm.zipCode].filter(Boolean).join(', '),
            State: vm.stateProvince.Abbr,
            ZipCode: vm.zipCode,
            Date: moment(vm.date, 'MM/DD/YYYY').format('MM/DD/YYYY'),
            Signature: vm.signimage,
        };

        if (vm.employeeBankInfo.CurrentSSN) {
            let ssnData = {
                Ssn1: vm.employeeSsn.slice(0, 3),
                Ssn2: vm.employeeSsn.slice(3, 5),
                Ssn3: vm.employeeSsn.slice(5)
            }
            formData = { ...formData, ...ssnData }
        }
        if (vm.employeeBankInfo.CurrentFEIN) {
            let feinData = {
                Ein1: vm.employeeFein.slice(0, 2),
                Ein2: vm.employeeFein.slice(2)
            }
            formData = { ...formData, ...feinData }
        }
        return onboardingDocumentService.save(vm.employee.UserName, formData, 0).then(function () {
            vm.isSaved = true;
            vm.showSavedNotification = true;
            vm.taxForm.$setPristine();
            return utilityService.hideLoading();
        }).catch((err) => {
            utilityService.hideLoading();
            console.log(err)
        });
    }

    function onApprove() {
        let approvePromise = onboardingDocumentService.approveOnboardingForm(vm.application.ApplicationId, "-2");
        const trans = $q.all(approvePromise).then((res) => {
            if (res) {
                vm.onShowI9();
            }
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Approve failed")
        );
    }
    //submit
    function onSubmit() {
        //utilityService.showLoading();
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        //if (vm.ownerView) {
        //    return vm.onApprove();
        //}

        let updatePromises = [];
        let submitApplicationPromise = $q.defer();
        //check if 
        vm.isRehireOrPostActiveEdit = vm.employeeProfile != null && (vm.employeeProfile.EmployeeStatusID === 1 || vm.employeeProfile.EmployeeStatusID === 3) && vm.application.ApplicationStatus === 'Pending';
        const isPendingResubmit = vm.application.ApplicationStatus === 'Pending'
            && (vm.application.W9 === 'Approved' || vm.application.W9 === 'Pending');

        if ((vm.taxForm && vm.taxForm.$dirty) || vm.savedData || vm.isSaved || vm.ownerView || vm.isRehireOrPostActiveEdit || isPendingResubmit || vm.isSigned || vm.application.W9 === 'ReviewRequired') {
            if (!vm.isSigned) {
                utilityService.hideLoading();
                alert("Preview and Signature are required");
            }
            if (!vm.signimage) {
                utilityService.hideLoading();
                alert("Signature is required");
                return;
            }

            vm.ssnfein = vm.employeeSsn ?? vm.employeeFein;
            let formData = {
                RequestTypeId: '-2',
                IsI9EmployeeMode: !vm.ownerView,
                EntityName: vm.entityName,
                BusinessName: vm.businessName,
                TaxClassification: vm.taxClass,
                OwnerTaxClassification: vm.othtaxclass,
                LLCClassification: vm.llctaxclass,
                ExemptPayeeCode: vm.exemptpayeecode,
                ComplianceAct: vm.complianceact,
                Line3a: vm.line3a === 'true',
                ReqNameAddress: vm.reqnameaddress,
                AccNos: vm.accnos,
                Address: vm.address,
                City: vm.city,
                W9CityState: [vm.city, vm.stateProvince.Abbr, vm.zipCode].filter(Boolean).join(', '),
                State: vm.stateProvince.Abbr,
                ZipCode: vm.zipCode,
                Date: moment(vm.date, 'MM/DD/YYYY').format('MM/DD/YYYY'),
                Signature: vm.signimage,
            };
            if (vm.employeeBankInfo.CurrentSSN) {
                let ssnData = {
                    Ssn1: vm.employeeSsn.slice(0, 3),
                    Ssn2: vm.employeeSsn.slice(3, 5),
                    Ssn3: vm.employeeSsn.slice(5)
                }
                formData = { ...formData, ...ssnData }
            }
            if (vm.employeeBankInfo.CurrentFEIN) {
                let feinData = {
                    Ein1: vm.employeeFein.slice(0, 2),
                    Ein2: vm.employeeFein.slice(2)
                }
                formData = { ...formData, ...feinData }
            }
            submitApplicationPromise = onboardingDocumentService.submit(vm.employee.UserName, formData, 0)
            updatePromises.push(submitApplicationPromise);
        }
        if (!Array.isArray(updatePromises) || updatePromises.length === 0) {
            if (vm.ownerView) {
                return onApprove();
            } else {
                return onShowI9();
            }

        }

        const trans = $q.all(updatePromises).then((res) => {
            if (res) {
                if (vm.ownerView) {
                    return onApprove();
                } else {
                    return onShowI9();
                }
            }
        }).catch((err) => {
            return $q.reject(err);
        });

        utilityService.showLoadingUntilResolved(
            utilityService.alertOnError(trans, "Save failed")
        );
    }

    //preview
    function onPreview() {
        if (vm.taxForm && vm.taxForm.$invalid) {
            alert("Form is invalid. Fill the required fields.");
            return;
        }
        utilityService.showLoading();
        vm.ssnfein = vm.employeeSsn ?? vm.employeeFein;
        let formData = {
            RequestTypeId: '-2',
            IsI9EmployeeMode: !vm.ownerView,
            EntityName: vm.entityName,
            BusinessName: vm.businessName,
            TaxClassification: vm.taxClass,
            OwnerTaxClassification: vm.othtaxclass,
            LLCClassification: vm.llctaxclass,
            ExemptPayeeCode: vm.exemptpayeecode,
            ComplianceAct: vm.complianceact,
            Line3a: vm.line3a === 'true',
            ReqNameAddress: vm.reqnameaddress,
            AccNos: vm.accnos,
            Address: vm.address,
            W9CityState: [vm.city, vm.stateProvince.Abbr, vm.zipCode].filter(Boolean).join(', '),
            City: vm.city,
            State: vm.stateProvince.Abbr,
            ZipCode: vm.zipCode,
            Date: moment(vm.date, 'MM/DD/YYYY').format('MM/DD/YYYY'),
            Signature: vm.signimage,
        };
        if (vm.employeeBankInfo.CurrentSSN) {
            let ssnData = {
                Ssn1: vm.employeeSsn.slice(0, 3),
                Ssn2: vm.employeeSsn.slice(3, 5),
                Ssn3: vm.employeeSsn.slice(5)
            }
            formData = { ...formData, ...ssnData }
        }
        if (vm.employeeBankInfo.CurrentFEIN) {
            let feinData = {
                Ein1: vm.employeeFein.slice(0, 2),
                Ein2: vm.employeeFein.slice(2)
            }
            formData = { ...formData, ...feinData }
        }
        return onboardingDocumentService.previewUrl(vm.employee.UserName, formData, 0)
            .then(function (result) {
                utilityService.hideLoading();
                vm.previewUrl = result;
                return $uibModal.open({
                    ...PreviewSignatureModal,
                    resolve: {
                        title: () => "W9",
                        previewUrl: () => {
                            return vm.previewUrl;
                        },
                        allowApprove: () => {
                            return canApproveForm(vm.application, '-2');
                        },
                        allowSign: () => {
                            return true;
                        }
                    }
                }).result
            }).then(function (data) {
                console.log(data);
                vm.signimage = data.dataUrl;
                vm.isSigned = data.dataUrl != null;
                //vm.ISPreview = true;
                return onSubmit();
            }).catch((err) => {
                utilityService.hideLoading();
                console.log(err)
            });
    }

    //capture esc key press
    $scope.$on('modal.closing', function (event, reason, closed) {
        if (reason !== 'ok') {
            return onClose(event);
        }
    });

    function onClose(event) {
        if (vm.taxForm && vm.taxForm.$dirty) {
            /* vm.close({ $value: 'cancel' });*/
            event.preventDefault();
            $uibModal.open({
                ...InfoModal,
                resolve: {
                    notification: () => {
                        return "Your form is not completed yet. Do you want to leave?"
                    },
                    state: () => {
                        return "application-status";
                    }
                },
                controller: function ConfirmModalController($uibModalInstance) {
                    'ngInject'
                    this.close = function () {
                        $uibModalInstance.dismiss();
                    };
                },
                size: 'sm',
                backdrop: 'static'
            }).result.then(function (data) {
                console.log(data);
                if (data === 'ok') {
                    vm.close({ $value: 'ok' });
                }
            }, function (dismiss) {
                console.log(dismiss);
            });
        }
    }



    function onShowI9() {
        vm.close({ $value: 'ok' });
    }

    function onShowFederalW4() {

    }

    function retrieveLocaleTranslations(localeID) {
        return localeService.retrieveLocaleTranslations(localeID)
            .then(function (translations) {
                return translations;
            });
    }

    function retrieveLocale() {
        return localeService.retrieveLocales()
            .then(function (locales) {
                console.log(vm.employeeBankInfo.CountryID);
                return locales.filter(function (locale) {
                    console.log(vm.employeeBankInfo.CountryID);
                    return locale.countryID === vm.employeeBankInfo.CountryID;
                })[0] || localeService.retrieveCurrentLocale();
            })
            .then(function (locale) {
                if (locale) {
                    return locale;
                }
            });
    }

    function ssnIsValidated() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.ssnChanged) {
            if ((vm.employeeBankInfo.SSN || "") !== (vm.employeeBankInfo.confirmSSN || "")) {
                return false;
            }
        }
        return true;
    }

    function ssnBlur() {
        if (vm.employeeBankInfo != null && vm.employeeBankInfo.SSN !== vm.employeeBankInfo.originalSSN) {
            vm.employeeBankInfo.ssnChanged = true;
        } else {
            vm.employeeBankInfo.ssnChanged = false;
        }
    }

    function revealSSNChar(ssn, char, i) {
        return i > 4;
    }
    function revealFEINChar(fein, char, i) {
        return i > 4;
    }
}


export const W9Modal = {
    component: "apexW9Modal",
    windowClass: 'xx-dialog pagespinner',
    size: 'lg',
    backdrop: 'static'
}
